<span
  class="card-difference"
  [ngClass]="{
    negative: (!invertColors && value < 0) || (invertColors && value > 0),
    positive: (!invertColors && value > 0) || (invertColors && value < 0),
    neutral: value === 0 || !value
  }"
>
  <ng-container *ngIf="value !== 0 && value">
    <i *ngIf="value < 0" class="fa-solid fa-caret-down"></i>
    <i *ngIf="value > 0" class="fa-solid fa-caret-up"></i>
    {{ value < 0 ? -value : value }}%
  </ng-container>
  <ng-container *ngIf="value === 0 || !value">
    <i class="fa-solid fa-minus"></i>
  </ng-container>
</span>
